import {NUMERIC_THOUSANDS_SEPARATOR} from '@fo/shared-types/constants';

const getStringNumberAsFloat = (inputValue: string): number => {
  const regExp = new RegExp(NUMERIC_THOUSANDS_SEPARATOR, 'g');
  const formattedValue = parseFloat(inputValue.replace(regExp, ''));

  return formattedValue;
};
export default getStringNumberAsFloat;
